import { type INut } from "../shared/IFood";
import Foods from "../data/Foods";
import Nuts from "../data/Nutrients";
//https://fdc.nal.usda.gov/food-details/1750339/nutrients

function Fact(props:{nut:INut, amount:number}) {
    return <div className="flex between gap-24">
        <label>{props.nut.name}</label>
        <div>{props.amount}{props.nut.unit}</div>
    </div>
}
export default function Factsheet(props:{foodId:number}){
    const item = Foods.i.row(props.foodId.toString())
    const items = item?.facts.map(fact => {
        const nut = Nuts.i.row(fact.nid.toString())
        if (nut) return <Fact key={fact.nid} nut={nut} amount={fact.amount}/>
        else return null
    }).filter(item => !!item)
    return items ? <div className="factsheet">{items}</div> : <div className="notfound">Not found</div>
}